module.exports = __webpack_public_path__ + "22feee065eb05c8721f4f858e7c85e63.svg";